import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetByProjectRequest, GetByProjectResponse, GetReportRequest, GetReportResponse, PostReportRequest, PostReportResponse } from './types/TReportServices';

const URL_Prefix = '/report';

export const reportService = createApi({
    reducerPath: 'reportService',
    baseQuery: getBaseQuery,
    tagTypes: ['Report'],
    endpoints: (builder) => ({
        getReport: builder.query<GetReportResponse, GetReportRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        postReport: builder.mutation<PostReportResponse, PostReportRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Report'],
        }),
        getByProject: builder.query<GetByProjectResponse, GetByProjectRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/get_by_project/${params.project_uuid}`,
                method: 'GET',
                params: params,
            }),
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetReportQuery,
    useLazyGetReportQuery,
    usePostReportMutation,
    useGetByProjectQuery,
    useLazyGetByProjectQuery,
} = reportService;